import { useState } from "react";
import { submitSignup, extractErrorMessage } from "./api";

const EMPTY_FORM = { name: "", email: "", why: "" };

// Encapsulates signup form state, submission and feedback handling.
export function useSignup() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [message, setMessage] = useState("");

  const setField = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email.trim()) return;
    setStatus("submitting");
    setMessage("");
    try {
      const data = await submitSignup(form);
      setStatus("success");
      setMessage(
        `You're in${data?.name ? `, ${data.name}` : ""}. We just added one more monkey to the field.`
      );
      setForm(EMPTY_FORM);
    } catch (err) {
      setStatus("error");
      setMessage(extractErrorMessage(err));
    }
  };

  return { form, status, message, setField, handleSubmit };
}
